
import apiNoAuth from "./apiNoAuth";

export const CSRF_HEADER_NAME = 'X-CSRFToken';
const CSRF_COOKIE_NAME = 'csrftoken';
const CSRF_STORAGE_KEY = 'csrfToken';
const CSRF_ENDPOINT = 'auth/csrf-cookie';

let pendingRequest = null;

const readCookie = (name) => {
    if (typeof document === 'undefined') {
        return null;
    }
    const pattern = new RegExp('(?:^|; )' + encodeURIComponent(name) + '=([^;]*)');
    const match = document.cookie.match(pattern);
    return match ? decodeURIComponent(match[1]) : null;
};

export const getCsrfToken = () => {
    const fromCookie = readCookie(CSRF_COOKIE_NAME);
    if (fromCookie) {
        return fromCookie;
    }
    if (typeof window !== 'undefined' && window.sessionStorage) {
        return window.sessionStorage.getItem(CSRF_STORAGE_KEY);
    }
    return null;
};

const storeToken = (token) => {
    if (token && typeof window !== 'undefined' && window.sessionStorage) {
        window.sessionStorage.setItem(CSRF_STORAGE_KEY, token);
    }
};

const extractToken = (response) => {
    if (!response) {
        return null;
    }
    const data = response.data;
    if (typeof data === 'string') {
        return data;
    }
    if (data?.csrfToken) {
        return data.csrfToken;
    }
    if (data?.token) {
        return data.token;
    }
    if (data?.csrf) {
        return data.csrf;
    }
    return null;
};

export const ensureCsrfToken = async (forceRefresh = false) => {
    if (!forceRefresh) {
        const existing = getCsrfToken();
        if (existing) {
            return existing;
        }
    }

    if (!pendingRequest) {
        pendingRequest = apiNoAuth.get(CSRF_ENDPOINT, {withCredentials: true})
            .then((response) => {
                const token = extractToken(response);
                if (token) {
                    storeToken(token);
                }
                return token;
            })
            .catch((error) => {
                console.warn('Failed to fetch CSRF token', error);
                return null;
            })
            .finally(() => {
                pendingRequest = null;
            });
    }

    return pendingRequest;
};


